<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="800" content-class="dialog-form-contract">
      <v-card :loading="isContractLoading" outlined>
        <v-card-title class="white--text blue">
          <div>
            <span v-if="event == 'create'">
              <v-icon color="white" left>mdi-plus-box-multiple</v-icon>{{ $t('contract.create_rental_contract') }}
            </span>
            <span v-if="event == 'edit'">
              <v-icon color="white" left>mdi-pencil</v-icon>{{ $t('contract.rental_contract_information') }}
            </span>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="dialog-form-contract-in overflow-y-auto py-5">
          <v-container grid-list-sm v-if="!isLoading && value">
            <v-row>
              <v-col cols="12">
                <div class="flex items-center justify-between">
                  <h2 class="mb-3">
                    <v-icon left>mdi-text-box-multiple</v-icon>{{ $t('contract.rental_contract_information') }}
                  </h2>
                </div>
              </v-col>
              <v-col cols="12">
                <span>{{ $t('contract.business_name') }}</span>
                <v-text-field solo background-color="grey lighten-4" prepend-inner-icon="mdi-circle" flat
                  :placeholder="$t('contract.business_name')" :label="$t('contract.business_name')" v-model="businessName" item-text="text"
                  item-value="val"></v-text-field>
              </v-col>
              <v-col cols="12">
                <span>{{ $t('market.rent_type') }}</span>
                <v-autocomplete prepend-inner-icon="mdi-tag" flat solo background-color="grey lighten-4"
                  :placeholder="$t('market.rent_type')" :label="$t('market.rent_type')" :items="stallTypeItems" v-model="stallType"
                  item-text="text" item-value="value"></v-autocomplete>
              </v-col>
              <v-col cols="4">
                <!-- <span>วันที่เริ่มสัญญา</span> -->
                <span>{{ $t('contract.start_date') }}</span>
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="startDate"
                  transition="scale-transition" offset-y min-width="auto" :disabled="booking ? true : false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field solo flat background-color="grey lighten-4" :value="$helper.datelabel(startDate)"
                      :label="$t('contract.start_date')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                      :disabled="booking ? true : false"></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title scrollable locale="th"
                    :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat" persistent-hint
                    :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth" :disabled="booking ? true : false">
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click="menu1 = false">{{ $t('cancel') }}</v-btn>
                    <v-btn text color="success" @click="$refs.menu1.save(startDate)">{{ $t('confirm') }}</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <span>{{ $t('contract.end_date') }}</span>
                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="endDate"
                  transition="scale-transition" offset-y min-width="auto" :disabled="booking ? true : false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field solo flat background-color="grey lighten-4" :value="$helper.datelabel(endDate)"
                      :label="$t('contract.end_date')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                      :disabled="booking ? true : false"></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" no-title scrollable locale="th" persistent-hint
                    :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat"
                    :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth" :disabled="booking ? true : false">
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click="menu2 = false">{{ $t('cancel') }}</v-btn>
                    <v-btn text color="success" @click="$refs.menu2.save(endDate); editEndDate()">{{ $t('confirm') }}</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <span>{{ $t('contract.contract_duration_days') }}</span>
                <v-currency-field :rules="[rules.loanMin]" @input="editContractDays"
                  :placeholder="$t('contract.contract_duration_days')" v-model="contractDays" outlined
                  :messages="dayMonthYearText()" />
              </v-col>
              <v-col cols="12">
                <div class="flex items-center justify-between">
                  <h2 class="mb-3">Credit Term</h2>
                </div>
              </v-col>
              <v-col cols="4">
                <div style="padding-top:10px;">{{ $t('market.due_date_after_bill') }}</div>
              </v-col>
              <v-col cols="2">
                <v-currency-field :label="$t('duration_day')" :placeholder="$t('duration_day')" v-model="creditTerm"
                  outlined></v-currency-field>
              </v-col>
              <v-col cols="3">
                <v-text-field disabled type="text" :value="dateTimeFormat(startDueDate, 'YYYY-MM-DD')"
                  :label="$t('market.example_document_issue_date')" :placeholder="$t('market.example_document_issue_date')" outlined></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field disabled type="text" :value="dateAddCreditTerm()" :label="$t('market.example_document_due_date')"
                  :placeholder="$t('market.example_document_due_date')" outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="flex justify-between">
                  <h2 class="mb-3">
                    <v-icon left>mdi-file-account</v-icon>{{ $t('contract.contractor_information') }}
                  </h2>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="success" elevation="0" icon @click="resetBilling" v-on="on" v-bind="attrs">
                        <v-icon>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('customer.in_case_need_to_update_trader_data') }}</span>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="12">
                <span>{{ $t('customer.company_name_and_customer_name') }}</span>
                <v-text-field solo flat background-color="grey lighten-4" :label="$t('customer.company_name_and_customer_name')"
                  v-model="billingData.name"></v-text-field>
              </v-col>
              <v-col cols='6'>
                <EditTaxId v-model='billingData.taxId' showLabel showWarning
                  :getIsVat="customerType == 'company' ? true : false"
                  :getIsExport="customerType == 'company' ? true : false" :getRules="rules" @onWriteData="onWriteData"
                  @input="billingData.taxId = $event" />
              </v-col>
              <v-col cols="6">
                <span>{{ $t('address.company_branch') }}</span>
                <v-text-field solo flat background-color="grey lighten-4" :label="$t('address.company_branch')"
                  v-model="billingData.branchName"></v-text-field>
              </v-col>
              <v-col cols="12">
                <span>{{ $t('account.address') }}</span>
                <v-autocomplete solo flat background-color="grey lighten-4" :label="$t('account.address')" v-model="billingData.address"
                  :items="itemsAddress"></v-autocomplete>
                <v-text-field v-if="billingData.address == 'other'" solo flat background-color="grey lighten-4"
                  :label="$t('validate.input_address')" v-model="billingData.otherAddress"></v-text-field>
              </v-col>
              <v-col cols="6">
                <span>{{ $t('account.phone_number') }}</span>
                <v-text-field solo flat background-color="grey lighten-4" :label="$t('account.phone_number')"
                  v-model="billingData.tel"></v-text-field>
              </v-col>
              <v-col cols="6">
                <span>{{ $t('account.email') }}</span>
                <v-text-field solo flat background-color="grey lighten-4" :label="$t('account.email')"
                  v-model="billingData.email"></v-text-field>
              </v-col>

              <v-col cols="12" v-show="isBillingNoSave">
                <span class="red--text">{{ $t('validate.in_case_need_to_save_bill_again') }}</span>
              </v-col>
              <v-col cols="12" v-if="event == 'create'">
                <div class="mb-5 d-flex justify-space-between align-center">
                  <h2 class="mb-3">
                    <v-icon left>mdi-layers</v-icon>{{ $t('market.market_title') }}
                  </h2>
                  <v-btn small elevation="0" color="primary" @click="addAreaProduct()" :disabled="booking ? true : false">
                    <v-icon left>mdi-plus-box</v-icon>{{ $t('area.add_area_stall') }}
                  </v-btn>
                </div>
                <!-- <pre>{{ areaIds_tmp }}</pre> -->
                <v-card flat v-for="(area, inx) of areaIds" :key="inx" class="my-2" outlined>
                  <template v-if="area">
                    <v-card-text class="d-flex justify-space-between">
                      <div>
                        <span>{{ $t('area.rented_stall') }}</span>
                        <h3>{{ area.area.name }}</h3>
                        <ul>
                          <li v-for="(product, index) of area.products" :key="`prod_` + index">{{ product.name }}</li>
                        </ul>
                      </div>
                      <div>
                        <v-btn color="warning" class="mr-2" elevation="0" small rounded
                          @click="changeAreaProductDialog(area)" v-if="!isNotCheckInArea">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn color="error" small rounded elevation="0" :disabled="booking ? true : false"
                          @click="removeArr(areaIds, inx)">{{ $t('area.cancel_stall') }}</v-btn>
                      </div>
                    </v-card-text>
                  </template>
                </v-card>
                <v-card flat v-if="areaIds.length < 1" color="grey lighten-4">
                  <v-card-text>{{ $t('validate.no_selected_stall_please_add_stall') }}</v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="isStartMeterData"
                  :label="$t('validate.new_contract_for_customer_system_will_use_first_meter_to_calculate_bill')" hide-details></v-checkbox>
              </v-col>
              <v-col cols="12" v-if="isStartMeterData && !isLoading">
                <template
                  v-if="(getMetersWater && getMetersWater.length > 0) || (getMetersElec && getMetersElec.length > 0)">
                  <div class="mb-5 d-flex justify-space-between align-center">
                    <h2 class="mb-3">
                      <v-icon left>mdi-layers</v-icon>{{ $t('meter.first_meter') }}
                    </h2>
                    <v-btn small v-if="isDigitalMeter" @click="getDigitalMeterUnit()" class="mx-1"
                      :disabled="isLoading || isLoadingDigitalMeter" outlined color="grey darken-3">
                      <v-icon class="me-2">mdi-cloud-download</v-icon>{{ $t('meter.read_data_digital_meter') }}
                    </v-btn>
                  </div>
                  <div class="ps-4" v-if="getMetersWater && getMetersWater.length > 0">
                    <p>
                      <b>{{ $t('meter.water_meter_checkin') }}</b>
                    </p>
                    <v-row>
                      <template v-for="meter in getMetersWater">
                        <template v-if="startMeterData[meter.objectId]">
                          <v-col :cols="isDigitalMeter ? '3' : '4'" :key="`water_${meter.objectId}`"
                            class="d-flex align-center ps-6">{{ meter.area.name }}</v-col>
                          <v-col cols="4" :key="`water2_${meter.objectId}`" class="d-flex align-center ps-6">
                            <template v-if="meter.name">{{ meter.name }}</template>
                            <template v-else-if="meter.isMain">{{ $t('main') }}</template>
                            <template v-else>{{ $t('additional') }}</template>
                          </v-col>
                          <v-col cols="4" :key="`water3_${meter.objectId}`" class="text-center">
                            <v-text-field background-color="rgb(211,237,244)" solo hide-details="auto"
                              class="input-center input-disable-appearance" type="text" style="opacity: 0.75"
                              v-model="startMeterData[meter.objectId].unit"></v-text-field>
                            <small v-if="meter.digitalMeterData && startMeterData[meter.objectId].dateTime"
                              :class="startMeterData[meter.objectId].isOffline ? 'red--text' : ''">{{ $t('updatedate') }}
                              {{ $moment(startMeterData[meter.objectId].dateTime).format('lll') }}</small>
                          </v-col>
                          <v-col v-if="isDigitalMeter" cols="1" :key="`water4_${meter.objectId}`"
                            class="text-center d-flex align-center">
                            <v-btn v-if="isMeterDateDialogCanRead(meter)" :disabled="isLoadingDigitalMeter" icon
                              @click="getDigitalMeterUnit(meter)">
                              <v-icon>mdi-cloud-download</v-icon>
                            </v-btn>
                          </v-col>
                        </template>
                      </template>
                    </v-row>
                  </div>
                  <div class="ps-4 mt-8" v-if="getMetersElec && getMetersElec.length > 0">
                    <v-row>
                      <v-col cols="6">
                        <b>{{ $t('meter.electricity_meter_checkin') }}</b>
                      </v-col>
                    </v-row>
                    <v-row>
                      <template v-for="meter in getMetersElec">
                        <template v-if="startMeterData[meter.objectId]">
                          <v-col :cols="isDigitalMeter ? '3' : '4'" :key="`elec_${meter.objectId}`"
                            class="d-flex align-center ps-6">{{ meter.area.name }}</v-col>
                          <v-col cols="4" :key="`elec2_${meter.objectId}`" class="d-flex align-center ps-6">
                            <template v-if="meter.name">{{ meter.name }}</template>
                            <template v-else-if="meter.isMain">{{ $t('main') }}</template>
                            <template v-else>{{ $t('additional') }}</template>
                          </v-col>
                          <v-col cols="4" :key="`elec3_${meter.objectId}`" class="text-center">
                            <v-text-field background-color="rgb(255, 0, 0, 0.3)" solo hide-details="auto"
                              class="input-center input-disable-appearance" type="text" style="opacity: 0.75"
                              v-model="startMeterData[meter.objectId].unit"></v-text-field>
                            <small v-if="meter.digitalMeterData && startMeterData[meter.objectId].dateTime"
                              :class="startMeterData[meter.objectId].isOffline ? 'red--text' : ''">{{ $t('updatedate') }}
                              {{ $moment(startMeterData[meter.objectId].dateTime).format('lll') }}</small>
                          </v-col>
                          <v-col v-if="isDigitalMeter" cols="1" :key="`elec4_${meter.objectId}`"
                            class="text-center d-flex align-center">
                            <v-btn v-if="isMeterDateDialogCanRead(meter)" :disabled="isLoadingDigitalMeter" icon
                              @click="getDigitalMeterUnit(meter)">
                              <v-icon>mdi-cloud-download</v-icon>
                            </v-btn>
                          </v-col>
                        </template>
                      </template>
                    </v-row>
                  </div>
                </template>
                <template v-else>
                  <div class="text-center">{{ $t('meter.no_meter_setting') }}</div>
                </template>
              </v-col>
            </v-row>
          </v-container>
          <v-card class="my-8" v-if="isLoading" elevation="0">
            <v-overlay absolute opacity="1" color="white">
              <v-progress-circular indeterminate color="green" size="70"></v-progress-circular>
            </v-overlay>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="dialog = false">
            <v-icon left>mdi-close</v-icon>{{ $t('cancel') }}
          </v-btn>
          <v-btn color="success" elevation="0" @click="recheckDialog = true" :loading="isContractLoading || isLoading"
            :disabled="!clickRule() || isLoading || contractDays <= 0">
            <v-icon left>mdi-clipboard-check-multiple-outline</v-icon>
            {{ event == "create" ? $t('contract.make_contract') : $t('save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FormAreaProducts v-model="areaProduct" @onSave="saveAreaProduct" @onSaveEdit="saveEditAreaProduct"
      :objectSelected="areaIds" :obj="areaSelectedObject" :isChangeArea="isChangeArea"></FormAreaProducts>
    <DigitalMeterDateDialog v-model="isMeterDateDialog" :isMainLoading="isLoading || isLoadingDigitalMeter" 
      :digitalMeterDataList="tempDigitalMeterDataList" @onSuccess="onDigitalMeterDate" />
    <v-snackbar v-model="isError" color="error" top>{{ $t('validate.error_occurred_while_performing_the_contract') }}</v-snackbar>
    <v-snackbar v-model="isReadSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('readsuccess') }}
    </v-snackbar>
    <v-dialog v-model="recheckDialog" persistent scrollable max-width="400">
      <v-card>
        <v-card-title>{{ $t('validate.you_want_to_do_or_save_contract', { action: event == "create" ? $t('do') : $t('save') }) }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-2">
          <div v-if="!billingData.name" class="text-orange-500">
            - {{ $t('not_specified_only') }} <b>{{ $t('market.company_name_or_customer_name') }}</b>
          </div>
          <div v-if="!billingData.taxId" class="text-orange-500">
            - {{ $t('not_specified_only') }} <b>{{ $t('contract.contractor_tax_id') }}</b>
          </div>
          <div v-if="!billingData.address" class="text-orange-500">
            - {{ $t('not_specified_only') }} <b>{{ $t('customer.trader_address') }}</b>
          </div>
          <div v-if="!billingData.tel" class="text-orange-500">
            - {{ $t('not_specified_only') }} <b>{{ $t('customer.trader_phone') }}</b>
          </div>
          <div v-if="!billingData.email" class="text-orange-500">
            - {{ $t('not_specified_only') }} <b>{{ $t('customer.trader_email') }}</b>
          </div>
          <div class="pt-2">
            {{ $t('validate.you_want_to_confirm_or_not_contract', { action: event == "create" ? $t('do') : $t('save') }) }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="recheckDialog = false" :disabled="isContractLoading || isLoading">
            <v-icon left>mdi-close</v-icon>{{ $t('cancel') }}
          </v-btn>
          <v-btn color="success" elevation="0" @click="event == 'create' ? createContract() : updateContract()"
            :loading="isContractLoading || isLoading"
            :disabled="!clickRule() || isLoading || contractDays <= 0 || isContractLoading">
            <v-icon left>mdi-check-bold</v-icon>{{ $t('confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FormAreaProducts from "./FormAreaProducts.vue";
import { mapGetters, mapActions } from "vuex";
import { DigitalMeter, DigitalWaterMeter } from "../classes";
import { Customer } from "../classes";
import DigitalMeterDateDialog from "@/components/DigitalMeterDateDialog.vue";
import EditTaxId from "@/components/EditTaxId.vue";
export default {
  name: "FormContract",
  components: {
    FormAreaProducts,
    DigitalMeterDateDialog,
    EditTaxId
  },
  computed: {
    stallTypeItems() {
      return [
        {
          text: this.$t('contact.stall_type.temporary'),
          value: "temporary"
        },
        {
          text: this.$t('contact.stall_type.regularly'),
          value: "regularly"
        }
      ];
    },
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    ...mapGetters({
      getGlobalId: "customer/getGlobalId",
      getProducts: "product/getProducts",
      vacancyAreas: "area/getVacancyAreas",
      getCustomer: "customer/getCustomer",
      getAddressArray: "customer/getAddressArray",
      getMetersWater: "meter/getMetersWater",
      getMetersElec: "meter/getMetersElec",
    }),
    itemsAddress() {
      let items = [];
      if (this.getAddressArray) {
        items = this.getAddressArray;
      }
      items.push({ text: this.$t('other'), value: "other" });
      if (this.billingData.address && this.billingData.address != "other") {
        let temp = items.find(i => i.value == this.billingData.address);
        if (!temp) {
          this.billingData.otherAddress = this.billingData.address;
          this.billingData.address = "other";
        }
      }
      return items;
    },
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
  },
  watch: {
    value(value) {
      if (value) {
        this.initData();
      }
    }
  },
  data() {
    return {
      projectId: this.$route.params.projectId,
      rules: {
        required: value => !!value || "Required.",
        loanMin: value => parseFloat(value) > 0 || this.$t('validate.contract_duration_must_be_greater_than_zero_days'),
        texId: v => v.length == 0 || v.length == 13 || this.$t('validate.please_input_data_correct_thirteen_digit'),
        numbersOnly: v => !v || /^\d+$/.test(v) || this.$t('validate.numbers_only'),
      },
      startDate: this.$moment().format("YYYY-MM-DD"),
      endDate: this.$moment().format("YYYY-MM-DD"),
      startDueDate: this.$moment().format("YYYY-MM-DD"),
      contractDays: 0,
      menu1: false,
      menu2: false,
      typeItems: [],
      type: "long",
      productIds: [],
      areaIds: [],
      internalId: "",
      erpId: "",
      isContractLoading: false,
      isError: false,
      isBillingNoSave: false,
      clickRule: () =>
        this.businessName != "" &&
        this.startDate != "" &&
        this.endDate != "" &&
        this.type != "" &&
        (this.areaIds != "" || this.event == "edit") &&
        (!this.billingData.taxId || this.billingData.taxId.length == 13)
      ,
      areaProduct: false,
      businessName: "",
      billingData: {
        name: "",
        address: "",
        otherAddress: "",
        taxId: "",
        branchCode: "",
        branchName: "",
        tel: "",
        email: ""
      },
      areaIds_tmp: [],
      isLoading: false,
      areaProductEvent: "create",
      areaSelectedObject: {},
      isChangeArea: false,
      stallType: "regularly",
      creditTerm: null,
      isStartMeterData: false,
      startMeterData: {},
      isDigitalMeter: false,
      isLoadingDigitalMeter: false,
      isReadSuccess: false,
      hashDigitalMetersUnit: null,
      areas: [],
      project: null,
      tempMeter: null,
      isMeterDateDialog: false,
      recheckDialog: false,
      customerType: '',
      digitalMeterDataList: null,
      tempDigitalMeterDataList: null
    };
  },
  props: {
    value: Boolean,
    event: String,
    obj: Object,
    areaObject: Object,
    booking: Object,
    isNotCheckInArea: Boolean,
    isNotUpdateStore: Boolean
  },
  created() {
    if (this.admins && this.admins.length) {
      this.project = this.admins[0].project;
    } else if (this.employees && this.employees.length) {
      this.project = this.employees[0].project;
    }

    this.typeItems = [
      { text: this.$t('long_term'), val: "long" },
      { text: this.$t('short_term'), val: "short" }
    ];
  },
  methods: {
    ...mapActions({
      getProduct: "product/getProducts",
      getVacancyAreas: "area/getVacancyAreas"
    }),
    async initData() {
      this.resetForm();
      if (this.event == "edit" && this.obj) {
        const newObj = Object.assign({}, this.obj);
        if (newObj?.products) {
          this.productIds = newObj?.products?.map(item => item.objectId);
        } else {
          this.productIds = [];
        }
        this.form = newObj;
        this.erpId = newObj.erpId;
        this.internalId = newObj.internalId;
        this.type = newObj.type;
        this.startDate = this.$moment(newObj?.startDate.iso).format(
          "YYYY-MM-DD"
        );
        this.endDate = this.$moment(newObj?.endDate.iso).format("YYYY-MM-DD");
        this.businessName = newObj?.businessName || "";
        this.stallType = newObj?.stallType || "";
        if (newObj.creditTerm != null && newObj.creditTerm > 0) {
          this.creditTerm = newObj.creditTerm;
        } else {
          this.creditTerm = null;
        }
        if (newObj.billingData) {
          this.customerType = newObj.customer ? newObj.customer.type : ''
          this.billingData = { ...newObj.billingData }
          this.isBillingNoSave = false;
        } else if (this.getCustomer) {
          this.customerType = this.getCustomer.type
          this.billingData = Customer.getBillingDataByCustomer(this.getCustomer)
          this.isBillingNoSave = true;
        } else {
          this.isBillingNoSave = true;
        }
        if (newObj.areas && newObj.areas.length) {
          for (let area of newObj.areas) {
            this.areaIds.push({
              area,
              products: area.products
            });
          }
        }
        this.startMeterData = newObj.startMeterData || {};
        if (newObj.startMeterData) this.isStartMeterData = true;
        this.form = newObj;
        this.loadMeter();
      } else {
        this.billingData = Customer.getBillingDataByCustomer(this.getCustomer)
        if (this.getCustomer) this.customerType = this.getCustomer.type
        if (
          this.booking &&
          this.booking.areaBookings &&
          this.booking.areaBookings.length
        ) {
          this.booking.areaBookings.map(ar =>
            this.areaIds.push({ area: ar.area, products: ar.products })
          );
          this.businessName = this.booking.businessName;
          this.stallType = this.booking.stallType;
          this.startDate = this.$moment(
            this.booking.areaBooking
              ? this.booking.areaBooking.startDate.iso
              : this.booking.areaBookings[0].startDate.iso
          ).format("YYYY-MM-DD");
          this.endDate = this.$moment(
            this.booking.areaBooking
              ? this.booking.areaBooking.endDate.iso
              : this.booking.areaBookings[0].endDate.iso
          ).format("YYYY-MM-DD");

          let customer = await this.$store.dispatch("customer/getCustomer", {
            id: this.booking.customer.objectId
          });
          this.billingData = Customer.getBillingDataByCustomer(customer);
          if (customer) this.customerType = customer.type
        } else {
          this.areaIds = [
            {
              area: this.areaObject,
              products: this.areaObject.products
            }
          ];
        }
        this.startMeterData = {};
        this.isStartMeterData = false;
        this.loadMeter();
      }
      this.editEndDate();
    },
    addAreaProduct() {
      this.isChangeArea = false;
      this.areaProduct = true;
    },
    async resetBilling() {
      if (!this.getCustomer || !this.getCustomer.id) {
        const newObj = Object.assign({}, this.obj);
        await this.$store.dispatch("customer/getCustomer", {
          id: newObj.customer.id
        });
      }
      if (this.getCustomer)
        this.customerType = this.getCustomer.type
      this.billingData = Customer.getBillingDataByCustomer(this.getCustomer)
      // .name =
      //   this.getCustomer.type == "personal"
      //     ? `${this.getCustomer.firstName} ${this.getCustomer.lastName}`
      //     : this.getCustomer.companyName;
      // const addressString = {
      //   subdistrict:
      //     this.getCustomer.addressProvince == "กรุงเทพมหานคร" ? "แขวง" : "ตำบล",
      //   district:
      //     this.getCustomer.addressProvince == "กรุงเทพมหานคร" ? "เขต" : "อำเภอ",
      //   province:
      //     this.getCustomer.addressProvince == "กรุงเทพมหานคร" ? "" : "จังหวัด"
      // };
      // this.billingData.address = `${this.getCustomer.addressStreet} ${addressString.subdistrict}${this.getCustomer.addressSubDistrict} ${addressString.district}${this.getCustomer.addressDistrict} ${addressString.province}${this.getCustomer.addressProvince} ${this.getCustomer.addressZipcode}`;
      // this.billingData.taxId = this.getCustomer.citizenId;
      // this.billingData.tel = this.getCustomer.tels[0] || "";
      // this.billingData.email = this.getCustomer.emails[0] || "";
    },
    changeAreaProductDialog(item) {
      this.isChangeArea = true;
      this.areaSelectedObject = item.area;
      this.areaSelectedObject.products = item.products;
      this.areaProduct = true;
    },
    async areaProductDialog() {
      this.isChangeArea = false;
      this.areaProduct = true;
    },
    saveAreaProduct(value) {
      const newValue = JSON.parse(JSON.stringify(value));
      this.areaIds.push(newValue);
      this.areaProduct = false;
      this.loadMeter();
    },
    saveEditAreaProduct(value) {
      const arr = this.areaIds.find(
        i => i.area.objectId == value.area.objectId
      );
      arr.area = value.area;
      arr.products = value.products;
      this.areaProduct = false;
      this.loadMeter();
    },
    removeArr(arr = [], index) {
      arr.splice(index, 1);
      this.$forceUpdate();
      this.loadMeter();
    },
    async updateContract() {
      try {
        this.isLoading = true;
        if (this.billingData.address == "other")
          this.billingData.address = this.billingData.otherAddress;
        if (this.billingData.otherAddress) delete this.billingData.otherAddress;
        let postData = {
          startDate: this.startDate,
          endDate: this.endDate,
          raw: this.form,
          internalId: this.internalId,
          erpId: this.erpId,
          type: this.type,
          productIds: this.productIds,
          billingData: this.billingData,
          businessName: this.businessName,
          stallType: this.stallType,
          isNotUpdateStore: this.isNotUpdateStore
        };
        if (this.creditTerm > -1) {
          postData.creditTerm = parseFloat(this.creditTerm);
        }
        if (this.isStartMeterData && this.areaIds) {
          let areaIds = this.areaIds.map(d => d.area.objectId);
          let allMeter = [...this.getMetersWater, ...this.getMetersElec].filter(
            d => areaIds.indexOf(d.area.objectId) > -1
          );
          let tempStartMeterData = {};
          for (let meter of allMeter) {
            if (this.startMeterData[meter.objectId]) {
              tempStartMeterData[meter.objectId] = this.startMeterData[
                meter.objectId
              ];
              tempStartMeterData[meter.objectId].unit = parseFloat(
                tempStartMeterData[meter.objectId].unit
              );
            }
          }
          postData.startMeterData = tempStartMeterData;
        }
        await this.$store.dispatch("contract/updateContract", postData);
        this.$emit("onUpdated");
        this.$eventBus.$emit("updateAreaPlan");
        this.isLoading = false;
        this.recheckDialog = false
        this.dialog = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
    async createContract() {
      this.isContractLoading = true;
      try {
        if (this.billingData.address == "other")
          this.billingData.address = this.billingData.otherAddress;
        if (this.billingData.otherAddress) delete this.billingData.otherAddress;
        let postData = {
          startDate: this.startDate,
          endDate: this.endDate,
          type: this.type,
          productIds: this.productIds,
          areaIds: this.areaIds,
          billingData: this.billingData,
          businessName: this.businessName,
          stallType: this.stallType
        };
        if (this.creditTerm > -1) {
          postData.creditTerm = parseFloat(this.creditTerm);
        }
        if (this.isStartMeterData && this.areaIds) {
          let areaIds = this.areaIds.map(d => d.area.objectId);
          let allMeter = [...this.getMetersWater, ...this.getMetersElec].filter(
            d => areaIds.indexOf(d.area.objectId) > -1
          );
          let tempStartMeterData = {};
          for (let meter of allMeter) {
            if (this.startMeterData[meter.objectId]) {
              tempStartMeterData[meter.objectId] = this.startMeterData[
                meter.objectId
              ];
              tempStartMeterData[meter.objectId].unit = parseFloat(
                tempStartMeterData[meter.objectId].unit
              );
            }
          }
          postData.startMeterData = tempStartMeterData;
        }
        if (this.isNotCheckInArea) {
          postData.isNotCheckInArea = this.isNotCheckInArea;
          postData.bookingId = this.booking ? this.booking.objectId : null
        } else {
          if (this.booking) {
            await this.$store.dispatch(
              "booking/checkInMonthlyBooking",
              this.booking.objectId
            );
          }
        }
        let contract = await this.$store.dispatch("contract/createContract", postData);
        this.isContractLoading = true;
        this.$emit("onCreateSuccess", contract);
        this.$eventBus.$emit('updateAreaPlan')
        this.recheckDialog = false
        this.dialog = false;
      } catch (error) {
        this.isContractLoading = false;
        this.isError = true;
      }
    },
    resetForm() {
      this.startDate = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.endDate = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.type = "long";
      this.stallType = "regularly";
      this.creditTerm = null;
      this.productIds = [];
      this.areaIds = [];
      this.internalId = "";
      this.erpId = "";
      this.isContractLoading = false;
      this.isError = false;
      this.isBillingNoSave = false;
      this.businessName = "";
      this.areaIds_tmp = [];
      this.billingData = {
        name: "",
        address: "",
        taxId: "",
        branchCode: "",
        branchName: "",
        tel: "",
        email: ""
      };
      this.startMeterData = {};
      this.isStartMeterData = false;
    },
    async loadMeter() {
      this.isLoading = true;
      this.digitalMeterDataList = [];
      if (this.areaIds) {
        this.isDigitalMeter = false;
        await this.$store.dispatch("meter/getMeterByAreas", {
          areaIds: this.areaIds.map(d => d.area.objectId)
        });
        for (let meter of [...this.getMetersWater, ...this.getMetersElec]) {
          if (meter.digitalMeterData && meter.digitalMeterData.type != "prepaid") {
            this.digitalMeterDataList.push(meter.digitalMeterData);
            this.isDigitalMeter = true;
          }
          if (!this.startMeterData[meter.objectId]) {
            this.startMeterData[meter.objectId] = {
              unit: 0,
              isUsed: false
            };
          }
        }
      }
      this.isLoading = false;
    },
    getDigitalMeterUnit(meter){
      this.tempMeter = null
      if(meter) {
        this.tempMeter = meter
        this.tempDigitalMeterDataList = [meter.digitalMeterData]
      } else {
        this.tempDigitalMeterDataList = this.digitalMeterDataList
      }
      this.isMeterDateDialog = true
    },
    onDigitalMeterDate(dateTime){
      if (this.tempMeter){
        this.loadDigitalMeterUnit(this.tempMeter, dateTime)
      } else {
        this.loadAllDigitalMeterUnit(dateTime)
      }
    },
    async loadDigitalMeterUnit(meter, dateTime) {
      this.isLoadingDigitalMeter = true;
      this.hashDigitalMetersUnit = {}
      try {
        let { partner, type, cust_id, meter_id } = meter.digitalMeterData
        if (meter.type == "elec") {
          this.hashDigitalMetersUnit = await DigitalMeter.getLatestMeterData(
            partner,
            type,
            cust_id,
            meter_id,
            dateTime
          )
        } else if (meter.type == "water") {
          this.hashDigitalMetersUnit = await DigitalWaterMeter.getLatestMeterData(
            partner,
            type,
            cust_id,
            meter_id,
            dateTime
          )
        }
        if (this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`]) {
          let data = this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`];
          this.startMeterData[meter.objectId].unit = data.unit || 0;
          this.startMeterData[meter.objectId].dateTime = data.datetime;
          this.startMeterData[meter.objectId].isOffline = data.isOffline
        }

        this.isReadSuccess = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false;
      } catch (err) {
        console.log(err);
        this.isError = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false;
      }
    },
    async loadAllDigitalMeterUnit(dateTime) {
      this.isLoadingDigitalMeter = true;
      try {
        if (this.isDigitalMeter) {
          let listElec = []
          let listWater = []
          for (let meter of this.getMetersElec) {
            if (meter.digitalMeterData) {
              let { partner, type, cust_id } = meter.digitalMeterData
              if (partner == 'xten') {
                listElec.push({...meter.digitalMeterData, dateTime})
              } else {
                if (!listElec.find(d => d.cust_id == cust_id && d.type == type)) listElec.push({partner, cust_id, type, dateTime})
              }
            }
          }
          for (let meter of this.getMetersWater) {
            if (meter.digitalMeterData) {
              let { partner, type, cust_id } = meter.digitalMeterData
              if (partner == 'xten') {
                listWater.push({...meter.digitalMeterData, dateTime})
              } else {
                if (!listWater.find(d => d.cust_id == cust_id && d.type == type)) listWater.push({partner, cust_id, type, dateTime})
              }
            }
          }

          let promises = []
          for (let data of listElec) {
            promises.push(DigitalMeter.getLatestMeterData(data.partner, data.type, data.cust_id, data.meter_id, data.dateTime))
          }
          for (let data of listWater) {
            promises.push(DigitalWaterMeter.getLatestMeterData(data.partner, data.type, data.cust_id, data.meter_id, data.dateTime))
          }

          let results = await Promise.all(promises)
          for (let data of results) {
            this.hashDigitalMetersUnit = {
              ...this.hashDigitalMetersUnit,
              ...data
            }
          }
        }

        for (let meter of [...this.getMetersWater, ...this.getMetersElec]) {
          if (meter.digitalMeterData) {
            let cust_id = meter.digitalMeterData.cust_id;
            let meter_id = meter.digitalMeterData.meter_id;

            if (
              this.startMeterData[meter.objectId] &&
              this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`]
            ) {
              let data = this.hashDigitalMetersUnit[`${cust_id}_${meter_id}`];
              this.startMeterData[meter.objectId].unit = data.unit || 0;
              this.startMeterData[meter.objectId].dateTime = data.datetime;
              this.startMeterData[meter.objectId].isOffline = data.isOffline
            }
          }
        }

        this.isReadSuccess = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false;
      } catch (err) {
        this.isError = true;
        this.isLoadingDigitalMeter = false;
        this.isMeterDateDialog = false;
      }
    },
    dateAddCreditTerm() {
      let text = "";
      if (this.creditTerm) {
        text = this.$moment()
          .add(this.creditTerm, "days")
          .format("DD/MM/YYYY");
      }
      return text;
    },
    dateTimeFormat(date, format, toFormat = "DD/MM/YYYY") {
      let text = "-";
      if (date && date.iso) {
        text = format
          ? this.$moment(date.iso, format).format(toFormat)
          : this.$moment(date.iso).format(toFormat);
      } else if (date) {
        text = format
          ? this.$moment(date, format).format(toFormat)
          : this.$moment(date).format(toFormat);
      }
      return text;
    },
    editEndDate() {
      this.contractDays = this.diffDays();
    },
    diffDays() {
      let days = 0;
      let minutes = 0;
      if (this.startDate && this.endDate) {
        minutes =
          this.$moment(this.endDate, "YYYY-MM-DD").diff(
            this.$moment(this.startDate, "YYYY-MM-DD"),
            "minutes"
          ) || 0;
        days = Math.ceil(minutes / (24 * 60)) + 1;
      }
      return days;
    },
    editContractDays(value) {
      let days = parseFloat(value);
      if (days && days > -1) {
        days--;
        let momentStartDate = this.$moment(this.startDate, "YYYY-MM-DD");
        momentStartDate.add(days, "days");
        this.endDate = momentStartDate.format("YYYY-MM-DD");
      }
    },
    dayMonthYearText() {
      let days = 0;
      let months = 0;
      let years = 0;
      let text = "";
      if (this.startDate && this.endDate) {
        let a = this.$moment(this.endDate, "YYYY-MM-DD").endOf("day");
        let b = this.$moment(this.startDate, "YYYY-MM-DD").startOf("day");
        a.add(1, "days");
        years = a.diff(b, "year");
        b.add(years, "years");
        months = a.diff(b, "months");
        b.add(months, "months");
        days = a.diff(b, "days");
      }
      if (years) {
        text += `${years} ${this.$t('year')} `;
      }
      if (months) {
        text += `${months} ${this.$t('month')} `;
      }
      if (days) {
        text += `${days} ${this.$t('day')}`;
      }
      return text;
    },
    onWriteData(dataTax) {
      if (this.customerType == 'company' && dataTax) {
        this.billingData.name = dataTax.companyName
        this.billingData.address = dataTax.fullAddress
        // this.$forceUpdate();
        // this.form.addressStreet = dataTax.addressStreet;
        // this.form.addressSubDistrict = dataTax.Thambol;
        // this.form.addressDistrict = dataTax.Amphur;
        // this.form.addressProvince = dataTax.Province;
        // this.form.addressZipcode = dataTax.PostCode;
      }
    },
    isMeterDateDialogCanRead(meter) {
      if (meter && meter.digitalMeterData && meter.digitalMeterData.meter_type != "prepaid") {
        return true
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-form-contract.v-dialog .dialog-form-contract-in.v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px);
}
</style>
